import { useModulesContext } from '../contexts';
export default function useRoutingMap() {
  var context = useModulesContext();
  var routingMap = context == null ? void 0 : context.routingMap;
  return routingMap;
}